import VisualVideoController from './VisualVideoController'
import StorySlide from './StorySlide'
import MovieSlide from './MovieSlide'

export default class {
  constructor() {

    const domVisualVideoController = document.querySelector('[data-js="hero"]');
    // console.log('Hero element found:', domVisualVideoController);
    if (domVisualVideoController) {
      // console.log('Creating VisualVideoController...');
      new VisualVideoController(domVisualVideoController);
    } else {
      // console.error('Hero element not found');
    }

    const domStorySlide = document.querySelector('[data-js="story-slide"]');
    if (domStorySlide) new StorySlide(domStorySlide);
    
    const domMovieSlide = document.querySelector('[data-js="movie-slide"]');
    if (domMovieSlide) new MovieSlide(domMovieSlide);
    
  }
}
